import { getCurrentInstance } from "vue"

export function useVuetify() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error(`useVuetify deve ser instanciada dentro da função setup().`)
  }
  return instance.proxy.$vuetify
}
